const capitalize = string => {
  if (typeof string === "string" && string.length > 0) {
    return `${string.charAt(0).toUpperCase()}${string
      .substring(1)
      .toLowerCase()}`;
  } else {
    return string;
  }
};

export default capitalize;
